import Vue from 'vue';

import UserInfo from './user-info/UserInfo.vue';
import PxAutocompleteMunicipioMultiple from './PxAutocompleteMunicipioMultiple.vue';
import PxAutocompleteEstadoMultiple from './PxAutocompleteEstadoMultiple.vue';
import PxPremiumBanner from './PxPremiumBanner.vue';
import PxPremiumBannerDialog from './PxPremiumBannerDialog.vue';
import PxStatusNegociacao from './PxStatusNegociacao.vue';
import PxAjudaIcon from './PxAjudaIcon.vue';

Vue.component('pxUserInfo', UserInfo);
Vue.component('PxAutocompleteMunicipioMultiple', PxAutocompleteMunicipioMultiple);
Vue.component('PxAutocompleteEstadoMultiple', PxAutocompleteEstadoMultiple);
Vue.component('PxPremiumBanner', PxPremiumBanner);
Vue.component('PxPremiumBannerDialog', PxPremiumBannerDialog);
Vue.component('PxStatusNegociacao', PxStatusNegociacao);
Vue.component('PxAjudaIcon', PxAjudaIcon);
